// Kept apart from forms.ts so a client bundle that needs only these doesn't carry its schemas.

/** The only slugs a reader may look up; also what keeps a slug safe to put in an R2 key. */
export const FORM_SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/

export const FORM_LANGS = ['sv', 'en', 'es', 'uk', 'fi'] as const

/** Base32 without the look-alikes 0, 1, l and o: the alphabet of a form id's suffix. */
export const FORM_ID_ALPHABET = '23456789abcdefghijkmnpqrstuvwxyz'

/**
 * A form id: `<type>-<lang>-<slug>-<suffix>`, e.g. `donation-sv-kyka-7f3k`. Drupal mints it once when the
 * form is created and never changes it, so after a rename its slug part is the old slug: treat the
 * id as opaque and never read meaning out of it. The parts: the document's `type` (English, so
 * `donation`), its FORM_LANGS language, a slug in FORM_SLUG_PATTERN's shape, and four characters
 * from FORM_ID_ALPHABET.
 */
export const FORM_ID_PATTERN = new RegExp(
  `^[a-z]+-(?:${FORM_LANGS.join('|')})-[a-z0-9]+(?:-[a-z0-9]+)*-[${FORM_ID_ALPHABET}]{4}$`,
)
